import React, {Fragment, useRef, useState} from 'react';
import {isEllipsisActive} from '@utils';
import Tooltip from 'antd/lib/tooltip';

type Props = {
    text: string;
};


function TextWithTooltip(props: Props) {
    const {text} = props;
    const [tooltip, setTooltip] = useState(false);
    const ref = useRef();

    const showTooltip = () => {
        setTooltip(isEllipsisActive(ref.current))
    };

    return (
        <Fragment>
            <div ref={ref}
                 className={`comment-text-wrapper`}
                 onMouseOver={() => showTooltip()}
                 onMouseLeave={() => setTooltip(false)}>
                {text.replace(/<[^>]+>/g, '')}
            </div>
            {tooltip && (
                <Tooltip
                    placement="bottomLeft"
                    visible={true}
                    title={
                        <div className={'comment-text-wrapper'} dangerouslySetInnerHTML={{__html: text}}/>}>
                </Tooltip>
            )}
        </Fragment>

    )
}

export default TextWithTooltip
